var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full text-center justify-center items-center h-screen bg-slate-100 gap-4"},[_c('p',[_vm._v(_vm._s(_vm.message))]),(_vm.showFallback)?_c('a',{staticClass:"px-4 py-2 bg-blue-500 text-white rounded",attrs:{"href":_vm.deepLink}},[_vm._v(" Tap here to return to the app ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }